import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allProductMarketsAction, clearErrors, createProductMarketAction, toggleProductMarketsAction, updateProductMarketAction, deleteProductMarketAction } from '../../redux/actions/userActions';
import { toast } from 'react-toastify';
import { Countries } from '../Prodcuts/countries';
import SearchSelect from '../../elements/OptionWithSearch';
import api from '../../api';


const ProductMarkets = () => {
    const dispatch = useDispatch();
    const { loading, error, message } = useSelector(state => state.createProductMarket);
    const { productMarkets } = useSelector(state => state.allProductMarkets);

    const [market, setMarket] = useState("");
    const [country, setCountry] = useState("");
    const [localMarkets, setLocalMarkets] = useState([]);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedMarket, setSelectedMarket] = useState(null);
    const [editMarket, setEditMarket] = useState("");
    const [editCountry, setEditCountry] = useState("");

    useEffect(() => {
        if (productMarkets) {
            setLocalMarkets(productMarkets);
        }
    }, [productMarkets]);

    const handleMoveUp = async (index) => {
        if (index === 0) return;
        const newMarkets = [...localMarkets];
        const temp = newMarkets[index];
        newMarkets[index] = newMarkets[index - 1];
        newMarkets[index - 1] = temp;
        setLocalMarkets(newMarkets);
        await saveOrder(newMarkets);
    };

    const handleMoveDown = async (index) => {
        if (index === localMarkets.length - 1) return;
        const newMarkets = [...localMarkets];
        const temp = newMarkets[index];
        newMarkets[index] = newMarkets[index + 1];
        newMarkets[index + 1] = temp;
        setLocalMarkets(newMarkets);
        await saveOrder(newMarkets);
    };

    const saveOrder = async (updatedMarkets) => {
        const orders = updatedMarkets.map((market, idx) => ({
            id: market.id,
            sort_order: idx
        }));
        try {
            const { data } = await api.put('/api/v1/update-market-order', { orders });
            if (data.success) {
                toast.success("Order updated successfully");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update order");
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!market) return toast.error("Please enter product market name");
        if (!country) return toast.error("Please select country");
        dispatch(createProductMarketAction({ market, country }));
    };

    useEffect(() => {
        if (message) {
            toast.success(message);
            dispatch({ type: "CREATE_PRODUCT_MARKET_RESET" });
            dispatch(allProductMarketsAction());
            setMarket("");
            setCountry("");
        }
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
    }, [message, error, dispatch]);

    useEffect(() => { dispatch(allProductMarketsAction()); }, [dispatch]);

    const handleEdit = (market) => {
        setSelectedMarket(market);
        setEditMarket(market.market);
        setEditCountry(market.country);
        setIsEditModalOpen(true);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this market?")) {
            dispatch(deleteProductMarketAction(id));
        }
    };

    const handleUpdateSubmit = () => {
        dispatch(updateProductMarketAction({ id: selectedMarket.id, market: editMarket, country: editCountry }));
        setIsEditModalOpen(false);
    };

    const handleToggle = (Market_id, is_active) => {
        dispatch(toggleProductMarketsAction(Market_id, is_active));
    };



    useEffect(() => {

        console.log(productMarkets?.length)
      
    }, [productMarkets])
    

    return (
        <Fragment>
            <form onSubmit={handleSubmit} className="mt-[2vmax]">
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-[1.5vmax] items-end'>
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Product Market Name <span className='text-red-500'>*</span></label>
                        <input
                            type="text"
                            value={market}
                            onChange={(e) => setMarket(e.target.value)}
                            className='w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700'
                            placeholder='Market name'
                        />
                    </div>
                    <div className='flex flex-col relative'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Country <span className='text-red-500'>*</span></label>
                        <SearchSelect
                            options={Countries}
                            value={country}
                            onChange={setCountry}
                            placeholder="Select country"
                            name="country"
                            classes="w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700"
                        />
                    </div>
                    <div className='flex justify-end gap-3 items-center'>
                        <button className='bg-gray-100 hover:bg-gray-200 text-gray-700 px-[1.5vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors' type='reset'>Cancel</button>
                        <button 
                            className={`bg-indigo-600 hover:bg-indigo-700 text-white px-[2vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed`} 
                            type='submit' 
                            disabled={loading || market === "" || country === ""}
                        >
                            {loading ? "Saving..." : "Save"}
                        </button>
                    </div>
                </div>
            </form>

            <div className="mt-[3vmax] overflow-x-auto">
                <h3 className="text-[1.2vmax] font-bold text-gray-800 mb-[1vmax]">Product Markets List</h3>
                <div className="flex bg-gray-50 py-[1vmax] rounded-lg w-[240%] lg:w-full mb-[1vmax]">
                    <span className='flex-[0.5] text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>No.</span>
                    <span className='flex-[1] text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Market</span>
                    <span className='flex-1 text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Country</span>
                    <span className='flex-1 text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Status</span>
                    <span className='flex-1 text-center text-gray-600 font-bold uppercase text-[0.8vmax]'>Action</span>
                </div>
                {localMarkets?.length > 0 ? (
                    localMarkets.map((Market, index) => (
                        <div key={Market.id} className="flex w-[240%] lg:w-full py-[1vmax] border border-gray-100 bg-white rounded-xl shadow-sm mb-[0.5vmax] items-center transition-all hover:shadow-md">
                            <span className='flex-[0.5] text-center text-gray-500 font-bold text-[0.9vmax] flex items-center justify-center gap-2' >
                                <span>{index + 1}</span>
                                <div className="flex flex-col text-xs text-indigo-600">
                                    <button 
                                        type="button"
                                        onClick={() => handleMoveUp(index)} 
                                        disabled={index === 0}
                                        className="hover:text-indigo-800 disabled:text-gray-300"
                                    >
                                        <i className="fa-solid fa-chevron-up"></i>
                                    </button>
                                    <button 
                                        type="button"
                                        onClick={() => handleMoveDown(index)} 
                                        disabled={index === localMarkets.length - 1}
                                        className="hover:text-indigo-800 disabled:text-gray-300"
                                    >
                                        <i className="fa-solid fa-chevron-down"></i>
                                    </button>
                                </div>
                            </span>
                            <span className='flex-[1] text-center text-gray-800 font-bold text-[0.9vmax]' >{Market.market}</span>
                            <span className='flex-1 text-center text-gray-700 text-[0.9vmax]'>{Market.country}</span>
                            <span className='flex-1 text-center flex justify-center'>
                                <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider
                                    ${Market.is_active === 1 ? 'text-green-700 bg-green-50' : "text-red-700 bg-red-50"}`}
                                >
                                    {Market.is_active === 1 ? "Active" : "Inactive"}
                                </span>
                            </span>
                            <div className="flex-1 text-center flex justify-center gap-2">
                                <button className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white
                                    ${Market.is_active === 0 ? "bg-emerald-600 hover:bg-emerald-700" : "bg-rose-600 hover:bg-rose-700"} 
                                    ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                    onClick={() => handleToggle(Market.id, Market.is_active === 1 ? 0 : 1)}
                                    disabled={loading}
                                >
                                    {Market.is_active === 0 ? "Activate" : "Deactivate"}
                                </button>
                                <button className="px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white bg-blue-600 hover:bg-blue-700"
                                    onClick={() => handleEdit(Market)}
                                >
                                    Edit
                                </button>
                                <button className="px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white bg-red-600 hover:bg-red-700"
                                    onClick={() => handleDelete(Market.id)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center text-[1.2vmax] text-gray-400 py-[2vmax]">No product Markets found</div>
                )}
            </div>

            {isEditModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg w-[30vmax]">
                        <h2 className="text-xl font-bold mb-4">Edit Product Market</h2>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Market Name</label>
                            <input
                                type="text"
                                value={editMarket}
                                onChange={(e) => setEditMarket(e.target.value)}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Country</label>
                            <SearchSelect
                                options={Countries}
                                value={editCountry}
                                onChange={(val) => setEditCountry(val)}
                                placeholder="Select Country"
                            />
                        </div>
                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setIsEditModalOpen(false)}
                                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateSubmit}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default ProductMarkets;
